import React, { useState } from "react";

const Avatar = ({ imageUrl, imageUrls = [], initials, name, size = "md" }) => {
  const candidates = [...new Set([imageUrl, ...imageUrls].map((value) => String(value || "").trim()).filter(Boolean))];
  const candidateKey = candidates.join("\n");
  const [imageState, setImageState] = useState({ key: candidateKey, index: 0 });
  const activeIndex = imageState.key === candidateKey ? imageState.index : 0;
  const activeImageUrl = candidates[activeIndex] || "";

  const handleImageError = () => {
    setImageState({ key: candidateKey, index: activeIndex + 1 });
  };

  return (
    <span className={`new-hrm-avatar new-hrm-avatar--${size}`} aria-label={name}>
      {activeImageUrl ? (
        <img key={activeImageUrl} src={activeImageUrl} alt="" onError={handleImageError} />
      ) : (
        initials
      )}
    </span>
  );
};

export default Avatar;
